import { TablistAppearance as FluentTablistAppearance, TablistOrientation as FluentTablistOrientation, TablistSize as FluentTablistSize } from "@fluentui/web-components";
/** Appearance values for Tablist. */
export const TablistAppearances = {
    ...FluentTablistAppearance
};
/** Orientation values for Tablist. */
export const TablistOrientations = {
    ...FluentTablistOrientation
};
/** Size values for Tablist. */
export const TablistSizes = {
    ...FluentTablistSize
};
/** Event names for Tablist. */
export const TablistEventNames = {
    activeIndexChange: "active-index-change",
    change: "change"
};
//# sourceMappingURL=tablist.options.js.map